import { createFileRoute, redirect } from "@tanstack/react-router";

import { JoinStep } from "~/pages/onboard/steps/join-step";

/**
 * Onboarding wizard variant of the `/join?id=xxx` invitation accept
 * screen. Reached when a mid-onboarding user follows an invitation link
 * (the `/join` route stashes the id in `sessionStorage` and forwards to
 * `/onboard`, which then redirects here once the user has finished the
 * profile + verify-email steps).
 *
 * Gating:
 *   - No session         -> /login
 *   - Profile incomplete -> /onboard/user
 *   - Email unverified   -> /onboard/verify-email
 *   - Already onboarded  -> /join?id=... (let the established-user
 *                                          standalone JoinPage handle it)
 *   - Otherwise (invitations | workspace) -> render the wizard step
 */
export const Route = createFileRoute("/onboard/join/$id")({
  beforeLoad: ({ context, params }) => {
    if (!context.user) {
      throw redirect({ to: "/login", replace: true });
    }
    switch (context.user.onboarding) {
      case "user":
        throw redirect({ to: "/onboard/user", replace: true });
      case "verifyEmail":
        throw redirect({ to: "/onboard/verify-email", replace: true });
      case "done":
        throw redirect({
          to: "/join",
          search: { id: params.id },
          replace: true,
        });
      case "invitations":
      case "workspace":
        return;
      default:
        throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: JoinStep,
});
